import { Grid } from '@mui/material'
import type { ReturnType } from '~/model'
import { ReturnTypeDetailInfoItem } from '~/components'

type Props = {
  returnType: ReturnType
  enabled: boolean
}

export const ReturnTypeDetailInfo = ({ returnType, enabled }: Props) => {
  const item = <ReturnTypeDetailInfoItem returnType={returnType} />

  return enabled ? (
    <Grid container direction="row" spacing={2} sx={{ marginBottom: 1 }}>
      {/* always show the left-most item in the grid, even without content */}
      <Grid size={{ xs: 12, sm: 6 }}>
        {returnType === 'pickup' && null}
        {returnType === 'service_point' && item}
      </Grid>
      {returnType === 'consumer_pickup' && <Grid size={{ xs: 12, sm: 6 }}>{item}</Grid>}
    </Grid>
  ) : null
}
